import React, { ComponentProps, FunctionComponent } from "react";

const LeaderboardIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 18 18",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M17.3571 16.7143H16.7143V15.1072C16.7143 14.5756 16.2815 14.1429 15.75 14.1429H12.2143V11.8929C12.2143 11.3613 11.7815 10.9286 11.25 10.9286H6.75C6.21846 10.9286 5.78571 11.3613 5.78571 11.8929V13.5H2.25C1.71846 13.5 1.28571 13.9328 1.28571 14.4643V16.7143H0.642857C0.287957 16.7143 0 17.0023 0 17.3572C0 17.7121 0.287957 18 0.642857 18H17.3571C17.712 18 18 17.7121 18 17.3572C18 17.0023 17.712 16.7143 17.3571 16.7143ZM15.4286 15.4286V16.7143H12.2143V15.4286H15.4286ZM7.07143 12.2143H10.9286V16.7143H7.07143V12.2143ZM2.57143 14.7857H5.78571V16.7143H2.57143V14.7857Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M11.0023 6.09385C12.3357 5.98587 13.8214 5.26266 13.8214 2.57142C13.8214 2.21652 13.5335 1.92856 13.1786 1.92856H11.5714C11.5714 1.57366 11.2835 1.28571 10.9286 1.28571H7.07145C6.71655 1.28571 6.42859 1.57366 6.42859 1.92856H4.82145C4.46655 1.92856 4.17859 2.21652 4.17859 2.57142C4.17859 5.26263 5.66436 5.98585 6.99773 6.09385C7.3401 6.52326 7.81135 6.83883 8.35712 6.98028V9.0001H7.71426C7.35936 9.0001 7.0714 9.28806 7.0714 9.64296C7.0714 9.99786 7.35936 10.2858 7.71426 10.2858H10.2857C10.6406 10.2858 10.9285 9.99786 10.9285 9.64296C10.9285 9.28806 10.6406 9.0001 10.2857 9.0001H9.64283V6.98028C10.1894 6.83799 10.6599 6.52242 11.0023 6.09385ZM12.4973 3.21428C12.3826 4.09319 12.0177 4.49331 11.5539 4.67577C11.5581 4.61634 11.5715 4.56026 11.5715 4.49999V3.21428L12.4973 3.21428ZM5.50279 3.21428H6.42857V4.49999C6.42857 4.56026 6.44196 4.61634 6.44615 4.67577C5.98157 4.4933 5.61745 4.09317 5.50279 3.21428ZM7.71422 4.49999V2.57142H10.2856V4.49999C10.2856 5.20898 9.70892 5.78571 8.99993 5.78571C8.29095 5.78571 7.71422 5.20898 7.71422 4.49999Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M1.92854 5.14283H1.28568C0.930779 5.14283 0.642822 4.85487 0.642822 4.49997C0.642822 4.14507 0.930779 3.85712 1.28568 3.85712H1.92854C2.28344 3.85712 2.57139 4.14507 2.57139 4.49997C2.57139 4.85487 2.28344 5.14283 1.92854 5.14283Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M16.7143 5.14283H16.0714C15.7165 5.14283 15.4286 4.85487 15.4286 4.49997C15.4286 4.14507 15.7165 3.85712 16.0714 3.85712H16.7143C17.0692 3.85712 17.3572 4.14507 17.3572 4.49997C17.3572 4.85487 17.0692 5.14283 16.7143 5.14283Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M3.19723 8.59235L2.64058 8.91378C2.33254 9.09123 1.93997 8.98577 1.7625 8.67856C1.58504 8.37136 1.68967 7.97795 1.99772 7.80048L2.55437 7.47905C2.8624 7.3016 3.25498 7.40706 3.43245 7.71427C3.60992 8.02148 3.50443 8.41488 3.19723 8.59235Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M16.0017 1.19947L15.445 1.5209C15.137 1.69835 14.7444 1.59288 14.5669 1.28567C14.3895 0.978466 14.4941 0.585067 14.8022 0.407596L15.3588 0.0861672C15.6669 -0.0912871 16.0594 0.0141801 16.2369 0.321389C16.4144 0.628589 16.3097 1.022 16.0017 1.19947Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M14.5674 7.71427C14.7448 7.40707 15.1374 7.3016 15.4454 7.47905L16.0021 7.80048C16.3101 7.97793 16.4148 8.37135 16.2373 8.67855C16.0599 8.98575 15.6673 9.09122 15.3592 8.91377L14.8026 8.59235C14.4954 8.41489 14.3899 8.02147 14.5674 7.71427Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M1.76323 0.321385C1.94068 0.0141849 2.33327 -0.0912866 2.6413 0.0861634L3.19795 0.407592C3.50599 0.585046 3.61063 0.978471 3.43318 1.28567C3.25573 1.59287 2.86313 1.69834 2.5551 1.52089L1.99845 1.19946C1.69041 1.02201 1.58578 0.628585 1.76323 0.321385Z",
    })
  );
};

const ForwardRef = React.forwardRef(LeaderboardIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
